import { render, staticRenderFns } from "./opt-in-cover.vue?vue&type=template&id=05dd2e4c&scoped=true"
import script from "./opt-in-cover.vue?vue&type=script&lang=js"
export * from "./opt-in-cover.vue?vue&type=script&lang=js"
import style0 from "./opt-in-cover.vue?vue&type=style&index=0&id=05dd2e4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05dd2e4c",
  null
  
)

export default component.exports